import { render, staticRenderFns } from "./serviceSet.vue?vue&type=template&id=6972c8a8&scoped=true&"
import script from "./serviceSet.vue?vue&type=script&lang=js&"
export * from "./serviceSet.vue?vue&type=script&lang=js&"
import style0 from "./serviceSet.vue?vue&type=style&index=0&id=6972c8a8&prod&lang=scss&scoped=true&"
import style1 from "./serviceSet.vue?vue&type=style&index=1&id=6972c8a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6972c8a8",
  null
  
)

export default component.exports